import styled, { css } from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const ContactItemLayout = css`
    display: inline-grid;
    grid-template-columns: minmax(232px, 1fr) minmax(232px, 1fr) 40px;
    column-gap: 16px;
    box-sizing: border-box;
    width: 100%;
    align-items: center;
`;

export const StyledModalDescription = styled.p`
    ${mixins.setFont({
        $size: 16,
        $weight: 400,
        $color: colorsPalettes.carbon[400],
    })};
    margin: 2px 24px 30px;
`;

export const StyledContactsListHeader = styled.div`
    padding: 0 32px 8px 24px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    ${ContactItemLayout}
`;

export const StyledContactsListHeading = styled.span`
    ${mixins.setFont({
        $size: 12,
        $weight: 500,
        $color: colorsPalettes.carbon[300],
    })};
    line-height: 16px;
`;

export const StyledContactsList = styled.div`
    overflow: scroll;
    width: 100%;
`;

export const modalStyles = {
    content: {
        width: "576px",
        padding: "0",
        maxHeight: "100%",
        display: "flex",
        flexDirection: "column",
    } as const,
};
